export default function HeroSection() {
  return (
    <div className="relative min-h-[520px] flex items-center overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('https://public.readdy.ai/ai/img_res/c8116f9bd2620812952f774124b15cd2.jpg')` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950/92 via-slate-900/75 to-slate-800/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-8 lg:px-16 py-20">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-400/40 text-orange-300 text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
            <i className="ri-shield-check-line"></i>
            Maintenance préventive certifiée RGE
          </div>

          <h1 className="text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-4">
            Contrats d'entretien<br />
            <span className="text-orange-400">Pompes à Chaleur</span>
          </h1>

          <p className="text-lg text-white/80 mb-8 leading-relaxed">
            Protégez votre investissement avec nos formules d'entretien sur-mesure. Maintenez vos performances optimales et prolongez la durée de vie de votre équipement.
          </p>

          <div className="flex flex-wrap gap-5 mb-10">
            {[
              { icon: 'ri-time-line', text: 'Intervention sous 24h à 72h' },
              { icon: 'ri-tools-line', text: 'Techniciens certifiés RGE' },
              { icon: 'ri-file-list-3-line', text: 'Rapport détaillé fourni' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-white/80 text-sm">
                <i className={`${item.icon} text-orange-400`}></i>
                {item.text}
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a href="#formules" className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-7 py-4 rounded-full transition-all hover:scale-105 cursor-pointer whitespace-nowrap text-center inline-block">
              Voir les formules
            </a>
            <a href="tel:0189293323" className="border-2 border-white/50 hover:border-white text-white font-semibold px-7 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap text-center inline-block">
              <i className="ri-phone-line mr-2"></i>01 89 29 33 23
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
